import { render, staticRenderFns } from "./Chanpindingwei.vue?vue&type=template&id=30687d4a&scoped=true"
import script from "./Chanpindingwei.vue?vue&type=script&lang=js"
export * from "./Chanpindingwei.vue?vue&type=script&lang=js"
import style0 from "./Chanpindingwei.vue?vue&type=style&index=0&id=30687d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30687d4a",
  null
  
)

export default component.exports